import { ObservableArray, View } from "binder"
import { ElementType, MultiSelectorBaseViewModel } from "./multiSelectorBase-viewModel"

export class MultiSelectorBaseView<T extends ElementType> extends View<MultiSelectorBaseViewModel<T>>{
    GetViewUniqueId(): string {
        return "V-E25E6DAA-AC00-4CAD-8A0F-F2AF8FB7CA7C"
    }
    loadHtml(): string {
        let element = require('./multiSelectorBase.html').default;
        let style = require('./multiSelectorBase.less');
        return element;
    }
    constructor() {
       super();
    }

    public set items(v: ObservableArray<T>) { this._items = v; } public get items(): ObservableArray<T> { return this._items;} private _items: ObservableArray<T>;
    public set selectedItems(v: ObservableArray<T>) { this._selectedItems = v; } public get selectedItems(): ObservableArray<T> { return this._selectedItems;} private _selectedItems: ObservableArray<T>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.dataContext.refresh();
    }
}
